// 상점 관리(shop_package) CSV 업로드 양식. key 는 DB 컬럼명, desc 는 양식/모달에 표시되는 설명이다.
export const SHOP_PACKAGE_CSV_COLUMNS = [
    {key: 'seq', desc: '비워두면 신규 등록 / 값이 있으면 해당 행 수정'},
    {key: 'index', desc: '패키지 인덱스. Shop_Package.csv 에 있는 index 만 사용 가능'},
    {key: 'packageName', desc: '운영툴에 표시할 패키지 이름'},
    {key: 'begin', desc: '판매 시작 일시. YYYY-MM-DD HH:mm:ss 또는 unix(초)'},
    {key: 'end', desc: '판매 종료 일시. YYYY-MM-DD HH:mm:ss 또는 unix(초)'},
    {key: 'onOff', desc: '노출 여부. 1=On / 0=Off'},
    {key: 'packageTime', desc: '패키지별 운영 시간(시간). 사용하지 않으면 0'},
    {key: 'saleType', desc: '할인 타입. 0=일반 / 1=패키지 할인'},
    {key: 'maxBuyCount', desc: '기간 내 최대 구매 횟수. 0=기간 내 1회(기존 동작)'},
    {key: 'coolTime', desc: '재구매 쿨타임(분). maxBuyCount 가 1 이상일 때만 사용'},
    {key: 'memo', desc: '운영 메모. 쉼표가 들어가면 큰따옴표로 감싸주세요'},
];
